import React from 'react';
import {  Form,Input,Button, Space,message,Divider } from 'antd';
import { hnrequest } from '@/utils'


const Rzdh = ({onsetHticks}) => {
  const [messageApi, contextHolderdh] = message.useMessage();
  const [paym] = Form.useForm();
  

  const onFinish = async (values) => {
   const res = await hnrequest.post('/p_urzdh', values)
   messageApi.open({
    type: res.return_code ,
    content: res.return_msg ,
})

setTimeout(() => { onsetHticks(res.ticks)}, 2000) 
    

  }
  return (
    <>
    {contextHolderdh}
    <Divider style={{ borderColor: '#7cb305' }}>认证次数兑换</Divider>
      <Form
        name="paym"
        form={paym}
        onFinish={onFinish}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 400,
        }}
        initialValues={{
          remember: true,
        }}
        autoComplete="off"

      >
        <Form.Item
          label="兑换次数"
          name="rzcs"
        >
         <Space><Input  placeholder='请输入数字'/><Button type="primary" htmlType="submit">兑换</Button></Space> 

        </Form.Item>


      </Form>
   
    </>
  )

}
export default Rzdh